import {init as RumAgent} from '@elastic/apm-rum';

const isDevEnvironment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const isApmEnabled = process.env.REACT_APP_ELASTIC_APM_ENABLED === 'true';
const hasApmServerUrl = Boolean(process.env.REACT_APP_ELASTIC_APM_SERVER_URL);
const shouldInitializeApm = !isDevEnvironment && isApmEnabled && hasApmServerUrl;

const apmRum = shouldInitializeApm
    ? RumAgent({
        serviceName: 'clientportal_ui',
        serverUrl: process.env.REACT_APP_ELASTIC_APM_SERVER_URL,
        environment: process.env.REACT_APP_ELASTIC_APM_ENVIRONMENT,
        active: true
    })
    : null;

export default apmRum;
